const AppStrings = {
    login: 'login',
    branchName: 'branchName',
    type: 'type',
    branch: 'branch',
    logout: 'logout',
    username: 'username',
    password: 'password',
    username_required: 'username_required',
    password_required: 'password_required',
    sign_to_your_account: 'sign_to_your_account',
    add_new_component: 'add_new_component',
    units_can_used: 'units_can_used',
    branch_required: 'branch_required',
    compositeComponents: 'compositeComponents',
    readyProducts: 'readyProducts',
    list_permissions: 'list_permissions',
    required_quantity: 'required_quantity',
    minQty: 'minQty',
    hotGroup: 'hotGroup',
    reqQty: 'reqQty',
    view: 'view',
    integer_value_required: 'integer_value_required',
    create: 'create',
    saveAndClose: 'saveAndClose',
    edit: 'edit',
    delete: 'delete',
    selectUnit: 'selectUnit',
    dashboard_permissions: 'dashboard_permissions',
    productId_required: 'productId_required',
    selectAll: 'selectAll',
    selectProduct: 'selectProduct',
    cost: 'cost',
    materials_list: 'materials_list',
    try_in_a_while: 'try_in_a_while',
    opertion_saved: 'opertion_saved',
    priceIncludeTax: 'priceIncludeTax',
    print: 'print',
    clearSelection: 'clearSelection',
    discountValue: 'discountValue',
    factor: 'factor',
    isSmall: 'isSmall',
    available_quantity: 'available_quantity',
    purchase_order_added_successfully: 'purchase_order_added_successfully',
    add_new_item: 'add_new_item',
    save: 'save',
    cancel: 'cancel',
    time: 'time',
    unit: 'unit',
    search: 'search',
    all: 'all',
    reset: 'reset',
    manual: "manual",
    home: 'home',
    reload_page: 'reload_page',
    relogin: 'relogin',
    relogin_message: 'relogin_message',
    session_expired: 'session_expired',
    add: 'add',
    list: 'list',
    date_required: 'date_required',
    date: 'date',
    actions: 'actions',
    main_menu: 'main_menu',
    branches: 'branches',
    back: 'back',
    categories: 'categories',
    units_of_measurement: 'units_of_measurement',
    flavors: 'flavors',
    offers: 'offers',
    discount_types: 'discount_types',
    taxes: 'taxes',
    description: 'description',
    currencies: 'currencies',
    payment_methods: 'payment_methods',
    suppliers: 'suppliers',
    materials: 'materials',
    finished_materials: 'finished_materials',
    raw_materials: 'raw_materials',
    returnValue: 'returnValue',
    credit_cards: 'credit_cards',
    assembled_materials: 'assembled_materials',
    assembled_material_components: 'assembled_material_components',
    prices_and_costs: 'prices_and_costs',
    purchases_and_warehouses: 'purchases_and_warehouses',
    purchase_invoices: 'purchase_invoices',
    input_vouchers: 'input_vouchers',
    output_vouchers: 'output_vouchers',
    transfer_vouchers: 'transfer_vouchers',
    delivery_companies: 'delivery_companies',
    define_companies: 'define_companies',
    delivery_discounts: 'delivery_discounts',
    user_management: 'user_management',
    user_groups: 'user_groups',
    users: 'users',
    user_permissions: 'user_permissions',
    branchId: 'branchId',
    branchNameAr: 'branchNameAr',
    branchNameEn: 'branchNameEn',
    taxId: 'taxId',
    phones: 'phones',
    mobiles: 'mobiles',
    website: 'website',
    email: 'email',
    address: 'address',
    city: 'city',
    street: 'street',
    enter: 'enter',
    price1: 'price1',
    add_new_branch: 'add_new_branch',
    list_branches: 'list_branches',
    edit_branch: 'edit_branch',
    delete_branch: 'delete_branch',
    close: 'close',
    finish_edit: 'finish_edit',
    deleteConfirmation: 'deleteConfirmation',
    confirm: 'confirm',
    list_products: 'list_products',
    add_new_product: 'add_new_product',
    productId: 'productId',
    productNameAr: 'productNameAr',
    productNameEn: 'productNameEn',
    category: 'category',
    barcode: 'barcode',
    price: 'price',
    price2: 'price2',
    price3: 'price3',
    price4: 'price4',
    taxPercentage: 'taxPercentage',
    taxable: 'taxable',
    saleable: 'saleable',
    discountable: 'discountable',
    isActive: 'isActive',
    isService: 'isService',
    choose: 'choose',
    noDataAvailable: 'noDataAvailable',
    drag_and_drop: 'drag_and_drop',
    or: 'or',
    browse_file: 'browse_file',
    icon: 'icon',
    yes: 'yes',
    no: 'no',
    branchNameAr_required: 'branchNameAr_required',
    branchId_required: 'branchId_required',
    branchNameEn_required: 'branchNameEn_required',
    category_required: 'category_required',
    barcode_required: 'barcode_required',
    price_required: 'price_required',
    unit_required: 'unit_required',
    productNameEn_required: 'productNameEn_required',
    productNameAr_required: 'productNameAr_required',
    taxPercentage_required: 'taxPercentage_required',
    icon_required: 'icon_required',
    product_added_successfully: 'product_added_successfully',
    product_updated_successfully: 'product_updated_successfully',
    product_deleted_successfully: 'product_deleted_successfully',
    branch_added_successfully: 'branch_added_successfully',
    branch_updated_successfully: 'branch_updated_successfully',
    branch_deleted_successfully: 'branch_deleted_successfully',
    something_went_wrong: 'something_went_wrong',
    preparationTime: 'preparationTime',
    list_composite_components: 'list_composite_components',
    list_components: 'list_components',
    quantity: 'quantity',
    edit_product: 'edit_product',
    quantity_required: 'quantity_required',
    note: 'note',
    componentId: 'componentId',
    product_required: 'product_required',
    component_added_successfully: 'component_added_successfully',
    component_updated_successfully: 'component_updated_successfully',
    material_already_added: 'material_already_added',
    delete_title: 'delete_title',
    delete_confirmation: 'delete_confirmation',
    update_just_quentity_or_note: 'update_just_quentity_or_note',
    component_deleted_successfully: 'component_deleted_successfully',
    cancel_editing: 'cancel_editing',
    category_added_successfully: 'category_added_successfully',
    category_updated_successfully: 'category_updated_successfully',
    category_deleted_successfully: 'category_deleted_successfully',
    add_new_category: 'add_new_category',
    list_categories: 'list_categories',
    edit_category: 'edit_category',
    categoryNameAr: 'categoryNameAr',
    categoryNameEn: 'categoryNameEn',
    categoryNameAr_required: 'categoryNameAr_required',
    categoryNameEn_required: 'categoryNameEn_required',
    categoryId: 'categoryId',
    categoryId_required: 'categoryId_required',
    unitNameEn: 'unitNameEn',
    unitNameAr: 'unitNameAr',
    unitNameEn_required: 'unitNameEn_required',
    unitNameAr_required: 'unitNameAr_required',
    unit_added_successfully: 'unit_added_successfully',
    unit_updated_successfully: 'unit_updated_successfully',
    unit_deleted_successfully: 'unit_deleted_successfully',
    add_new_unit: 'add_new_unit',
    list_units: 'list_units',
    edit_unit: 'edit_unit',
    unitId: 'unitId',
    unitId_required: 'unitId_required',
    flavorId: 'flavorId',
    flavorId_required: 'flavorId_required',
    flavorNameAr: 'flavorNameAr',
    flavorNameEn: 'flavorNameEn',
    flavorNameAr_required: 'flavorNameAr_required',
    flavorNameEn_required: 'flavorNameEn_required',
    flavor_added_successfully: 'flavor_added_successfully',
    flavor_updated_successfully: 'flavor_updated_successfully',
    flavor_deleted_successfully: 'flavor_deleted_successfully',
    add_new_flavor: 'add_new_flavor',
    list_flavors: 'list_flavors',
    edit_flavor: 'edit_flavor',
    add_new_offer: 'add_new_offer',
    list_offers: 'list_offers',
    edit_offer: 'edit_offer',
    offerId: 'offerId',
    offerId_required: 'offerId_required',
    offerNameAr: 'offerNameAr',
    offerNameEn: 'offerNameEn',
    offerNameAr_required: 'offerNameAr_required',
    offerNameEn_required: 'offerNameEn_required',
    offer_added_successfully: 'offer_added_successfully',
    offer_updated_successfully: 'offer_updated_successfully',
    offer_deleted_successfully: 'offer_deleted_successfully',
    to_date: 'to_date',
    from_date: 'from_date',
    offerTypeAr: 'offerTypeAr',
    offerTypeEn: 'offerTypeEn',
    offerValue: 'offerValue',
    free_product: 'free_product',
    product: 'product',
    price_offer: 'price_offer',
    from_date_required: 'from_date_required',
    to_date_required: 'to_date_required',
    discount_percentage: 'discount_percentage',
    discount_percentage_required: 'discount_percentage_required',
    discount_type_ar: 'discount_type_ar',
    discount_type_en: 'discount_type_en',
    discount_type_ar_required: 'discount_type_ar_required',
    discount_type_en_required: 'discount_type_en_required',
    discountId: 'discountId',
    discount_added_successfully: 'discount_added_successfully',
    discount_updated_successfully: 'discount_updated_successfully',
    discount_deleted_successfully: 'discount_deleted_successfully',
    add_new_discount: 'add_new_discount',
    list_discounts: 'list_discounts',
    edit_discount: 'edit_discount',
    isDefault: 'isDefault',
    tax_type_ar: 'tax_type_ar',
    tax_type_en: 'tax_type_en',
    tax_type_ar_required: 'tax_type_ar_required',
    tax_type_en_required: 'tax_type_en_required',
    tax_added_successfully: 'tax_added_successfully',
    tax_updated_successfully: 'tax_updated_successfully',
    tax_deleted_successfully: 'tax_deleted_successfully',
    add_new_tax: 'add_new_tax',
    list_taxes: 'list_taxes',
    edit_tax: 'edit_tax',
    taxId_required: 'taxId_required',
    tax_type_id: 'tax_type_id',
    currencyId: 'currencyId',
    currencyId_required: 'currencyId_required',
    iDigits: 'iDigits',
    iDigits_required: 'iDigits_required',
    currency_added_successfully: 'currency_added_successfully',
    currency_updated_successfully: 'currency_updated_successfully',
    currency_deleted_successfully: 'currency_deleted_successfully',
    add_new_currency: 'add_new_currency',
    list_currencies: 'list_currencies',
    edit_currency: 'edit_currency',
    deliveryCompanyId: 'deliveryCompanyId',
    deliveryCompanyId_required: 'deliveryCompanyId_required',
    deliveryCompany_added_successfully: 'deliveryCompany_added_successfully',
    deliveryCompany_updated_successfully: 'deliveryCompany_updated_successfully',
    deliveryCompany_deleted_successfully: 'deliveryCompany_deleted_successfully',
    add_new_deliveryCompany: 'add_new_deliveryCompany',
    list_deliveryCompanies: 'list_deliveryCompanies',
    edit_deliveryCompany: 'edit_deliveryCompany',
    deliveryCompanyName: 'deliveryCompanyName',
    deliveryCompanyName_required: 'deliveryCompanyName_required',
    deliveryPercentage: 'deliveryPercentage',
    deliveryCompany_required: 'deliveryCompany_required',
    priceCategory: 'priceCategory',
    deliveryPercentage_required: 'deliveryPercentage_required',
    priceCategory_required: 'priceCategory_required',
    deliveryCompany: 'deliveryCompany',
    paymentTypeId: 'paymentTypeId',
    paymentTypeId_required: 'paymentTypeId_required',
    paymentType_added_successfully: 'paymentType_added_successfully',
    paymentType_updated_successfully: 'paymentType_updated_successfully',
    paymentType_deleted_successfully: 'paymentType_deleted_successfully',
    add_new_paymentType: 'add_new_paymentType',
    list_paymentTypes: 'list_paymentTypes',
    edit_paymentType: 'edit_paymentType',
    paymentTypeAr: 'paymentTypeAr',
    paymentTypeAr_required: 'paymentTypeAr_required',
    paymentTypeEn: 'paymentTypeEn',
    paymentTypeEn_required: 'paymentTypeEn_required',
    paymentType: 'paymentType',
    isCredit: 'isCredit',
    cashMoney: 'cashMoney',
    commissions: 'commissions',
    commissions_required: 'commissions_required',
    contactName: 'contactName',
    supplierCompany: 'supplierCompany',
    supplierId: 'supplierId',
    supplierId_required: 'supplierId_required',
    supplier_added_successfully: 'supplier_added_successfully',
    supplier_updated_successfully: 'supplier_updated_successfully',
    supplier_deleted_successfully: 'supplier_deleted_successfully',
    add_new_supplier: 'add_new_supplier',
    list_suppliers: 'list_suppliers',
    edit_supplier: 'edit_supplier',
    supplierCompany_required: 'supplierCompany_required',
    list_delivery_discount: 'list_delivery_discount',
    add_new_delivery_discount: 'add_new_delivery_discount',
    edit_delivery_discount: 'edit_delivery_discount',
    delivery_discount_added_successfully: 'delivery_discount_added_successfully',
    delivery_discount_updated_successfully: 'delivery_discount_updated_successfully',
    delivery_discount_deleted_successfully: 'delivery_discount_deleted_successfully',
    groupId: 'groupId',
    group_name_ar: 'group_name_ar',
    group_name_en: 'group_name_en',
    group_name_ar_required: 'group_name_ar_required',
    group_name_en_required: 'group_name_en_required',
    group_added_successfully: 'group_added_successfully',
    group_updated_successfully: 'group_updated_successfully',
    group_deleted_successfully: 'group_deleted_successfully',
    add_new_group: 'add_new_group',
    list_groups: 'list_groups',
    edit_group: 'edit_group',
    user_group: 'user_group',
    userId: 'userId',
    user_added_successfully: 'user_added_successfully',
    user_updated_successfully: 'user_updated_successfully',
    user_deleted_successfully: 'user_deleted_successfully',
    add_new_user: 'add_new_user',
    list_users: 'list_users',
    edit_user: 'edit_user',
    user_group_required: 'user_group_required',
    please_add_at_least_one_unit: 'please_add_at_least_one_unit',
    startWork: 'startWork',
    list_user_permissions: 'list_user_permissions',
    edit_permissions: 'edit_permissions',
    user_permissions_updated_successfully: 'user_permissions_updated_successfully',
    permission0101: 'permission0101',
    permission0102: 'permission0102',
    permission0103: 'permission0103',
    permission0104: 'permission0104',
    permission0105: 'permission0105',
    permission0106: 'permission0106',
    permission0107: 'permission0107',
    permission0108: 'permission0108',
    permission0109: 'permission0109',
    permission0110: 'permission0110',
    permission0111: 'permission0111',
    permission0112: 'permission0112',
    permission0113: 'permission0113',
    permission0114: 'permission0114',
    permission0115: 'permission0115',
    permission0116: 'permission0116',
    permission0117: 'permission0117',
    permission0118: 'permission0118',
    permission0119: 'permission0119',
    permission0120: 'permission0120',
    permission0121: 'permission0121',
    permission0122: 'permission0122',
    permission0123: 'permission0123',
    edit_user_permission: 'edit_user_permission',
    list_invoices: 'list_invoices',
    add_new_invoice: 'add_new_invoice',
    invoice_added_successfully: 'invoice_added_successfully',
    invoice_updated_successfully: 'invoice_updated_successfully',
    invoice_deleted_successfully: 'invoice_deleted_successfully',
    edit_invoice: 'edit_invoice',
    grandTotal: 'grandTotal',
    invoiceId: 'invoiceId',
    invoiceNo: 'invoiceNo',
    subTotal: 'subTotal',
    taxValue: 'taxValue',
    createdBy: 'createdBy',
    voucherId: 'voucherId',
    voucher_deleted_successfully: 'voucher_deleted_successfully',
    add_new_voucher_output: 'add_new_voucher_output',
    list_vouchers_output: 'list_vouchers_output',
    edit_voucher_output: 'edit_voucher_output',
    list_vouchers_input: 'list_vouchers_input',
    add_new_voucher_input: 'add_new_voucher_input',
    edit_voucher_input: 'edit_voucher_input',
    voucher_added_successfully: 'voucher_added_successfully',
    voucher_updated_successfully: 'voucher_updated_successfully',
    add_first_item_invoice: 'add_first_item_invoice',
    add_item_for_invoice: 'add_item_for_invoice',
    output_type: 'output_type',
    from_branch: 'from_branch',
    to_branch: 'to_branch',
    add_first_item_voucher: 'add_first_item_voucher',
    add_new_voucher_transfer: 'add_new_voucher_transfer',
    list_vouchers_transfer: 'list_vouchers_transfer',
    damaged: 'damaged',
    normal_output: 'normal_output',
    edit_voucher_transfer: 'edit_voucher_transfer',
    add_item_for_voucher: 'add_item_for_voucher',
    reports: 'reports',
    full_sales: 'full_sales',
    sales_category: 'sales_category',
    sales_items: 'sales_items',
    sales_cashier: 'sales_cashier',
    best_seller_items: 'best_seller_items',
    best_seller_category: 'best_seller_category',
    sales_by_days: 'sales_by_days',
    sales_by_hours: 'sales_by_hours',
    salesman_sales: 'salesman_sales',
    return_invoices: 'return_invoices',
    return_items: 'return_items',
    invoices_by_date: 'invoices_by_date',
    item_transaction: 'item_transaction',
    inventory_statement: 'inventory_statement',
    inventory_by_date: 'inventory_by_date',
    daily_profit: 'daily_profit',
    daily_profit_by_date: 'daily_profit_by_date',
    items_profits: 'items_profits',
    item_sales_transaction: 'item_sales_transaction',
    full_sales_with_details: 'full_sales_with_details',
    point_of_sale: 'point_of_sale',
    totalDiscount: 'totalDiscount',
    totalGrandTotal: 'totalGrandTotal',
    totalSubTotal: 'totalSubTotal',
    totalTaxTotal: 'totalTaxTotal',
    invoiceCount: 'invoiceCount',
    station_required: 'station_required',
    profitPercentage: 'profitPercentage',
    profitValue: 'profitValue',
    unitCost: 'unitCost',
    totalReturn: 'totalReturn',
    quantityReturned: 'quantityReturned',
    quantitySold: 'quantitySold',
    totalSales: 'totalSales',
    quantityIncoming: 'quantityIncoming',
    costIncoming: 'costIncoming',
    quantityOutgoing: 'quantityOutgoing',
    costOutgoing: 'costOutgoing',
    quantityBalance: 'quantityBalance',
    costBalance: 'costBalance',
    visa: 'visa',
    cashier: 'cashier',
    returnId: 'returnId',
    cashReturnValue: 'cashReturnValue',
    visaReturnValue: 'visaReturnValue',
    cashReturnValueTotal: 'cashReturnValueTotal',
    visaReturnValueTotal: 'visaReturnValueTotal',
    page_not_found: 'page_not_found',
    go_back_home: 'go_back_home',
    recieving_voucher: 'recieving_voucher',
    provide_voucher: 'provide_voucher',
    purchase_order: 'purchase_order',
    add_new_voucher_receiving: 'add_new_voucher_receiving',
    list_vouchers_receiving: 'list_vouchers_receiving',
    reciever: 'reciever',
    sender: 'sender',
    source_id: 'source_id',
    list_purchase_orders: 'list_purchase_orders',
    purchase_order_deleted_successfully: 'purchase_order_deleted_successfully',
    add_new_purchase_order: 'add_new_purchase_order',
    status: "status",
    day_name: "day_name",
    diff_rate: "diff_rate",
    all_days: "all_days",
    provided: "provided",
    list_vouchers_provide: "list_vouchers_provide",
    add_new_voucher_provide: "add_new_voucher_provide",

    edit_voucher_receiving: "edit_voucher_receiving",
    edit_voucher_provide: "edit_voucher_provide",
    edit_purchase_order: "edit_purchase_order",

    sent_qty: "sent_qty",
    received_qty: "received_qty",
    posted: "posted",
    approved: "approved",
    restaurant: "Restaurant",
restaurant_invoices: "Restaurant Invoices",
customerId: "Customer ID",
customerName: "Customer Name",
list_customers: "List Customers",
add_new_customer: "Add New Customer",
edit_customer: "Edit Customer",
customer_added_successfully: "Customer added successfully",
customer_updated_successfully: "Customer updated successfully",
customer_deleted_successfully: "Customer deleted successfully",
customerNameAr: "Customer Name (Arabic)",
customerNameEn: "Customer Name (English)",
customerNameAr_required: "Customer Name (Arabic) is required",
customerNameEn_required: "Customer Name (English) is required",
companyCustomer: "Company Customer",
companyName: "Company Name",
buildingNo: "Building No",
floorNo: "Floor No",
latitude: "Latitude",
longitude: "Longitude",
companyCustomer_required: "Company Customer is required",
companyName_required: "Company Name is required",
buildingNo_required: "Building No is required",
floorNo_required: "Floor No is required",
latitude_required: "Latitude is required",
longitude_required: "Longitude is required",
customer:"Customer",
cash:"Cash",
visa_card:"Visa Card",
financial_obligations:"Financial Obligations",
sales_invoices:"Sales Invoices",
list_sales_invoices:"List Sales Invoices",
add_new_sales_invoice:"Add New Sales Invoice",
edit_sales_invoice:"Edit Sales Invoice",
sales_invoice_added_successfully:"Sales Invoice added successfully",
sales_invoice_updated_successfully:"Sales Invoice updated successfully",
sales_invoice_deleted_successfully:"Sales Invoice deleted successfully",
isFront: "Is Front",
isBack: "Is Back",


}













export default AppStrings

